// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DdjDocumentCore, DocumentWithInternalType, InternalDocumentType } from '@interfaces/document.interfaces';

@Pipe({
    name: 'activeInternalDocumentType',
})
export class ActiveInternalDocumentTypePipe implements PipeTransform {
    private internalDocuments: InternalDocumentType[];

    constructor(private readonly route: ActivatedRoute) {
        this.internalDocuments = this.route.snapshot.data.internalDocTypes;
    }

    transform(items: DocumentWithInternalType[]): any[] {
        if (!items) return [];
        if (!this.internalDocuments || this.internalDocuments.length === 0) {
            return items;
        }
        return items.filter((i) => {
            const internalDoc = this.internalDocuments.find((id) => id.internalDocumentTypeId == i.internalDocumentTypeId);
            return !internalDoc || internalDoc.active;
        });
    }
}
